import * as React from 'react';
import {Route, Switch} from 'react-router-dom';
import * as routes from '../../util/routes';
// import {LocalAuthorityAdd, LocalAuthorityList} from '../../component/local-authority';
import LocalAuthorityList from '../../component/page/local-authority-list-page'

export default class LocalAuthoritiesContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      localAuthorities: []
    };
  }

  render() {
		return (
      <Switch>
				{/* <Route exact path={routes.LOCAL_AUTHORITIES} component={LocalAuthorityList}/>
        <Route path={routes.LOCAL_AUTHORITIES_ADD} component={LocalAuthorityAdd}/> */}
        <Route exact path={routes.LOCAL_AUTHORITIES} component={LocalAuthorityList}/>
				{/* <Route path={`${routes.LOCAL_AUTHORITIES}:localAuthoritySlug`} component={LocalAuthorityDetail}/> */}
			</Switch>
		);
  }
}


// WEBPACK FOOTER //
// ./src/route/secured/local-authorities.js